import React from "react";

import { translate } from "react-i18next";

import { Box, Text } from "src/components";

const List = ({ items, t, renderItem, emptyMessageKey }) =>
  items && items.length ? (
    <Box
      borderColor="divider"
      borderTop={true}
      borderBottom={true}
      borderWidth={1}
    >
      {items.map((item, index) =>
        renderItem({
          item,
          key: item.id || index,
          t,
          firstItem: index === 0,
        })
      )}
    </Box>
  ) : (
    <Box mx={3} py={3}>
      <Text color="muted" align="center">
        {t(emptyMessageKey)}
      </Text>
    </Box>
  );

export default translate("translations")(List);



// WEBPACK FOOTER //
// ./src/banking/components/List/List.js